import { render, staticRenderFns } from "./ListAssessment.vue?vue&type=template&id=0d46d1e2&"
import script from "./ListAssessment.vue?vue&type=script&lang=js&"
export * from "./ListAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ListAssessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports